import { JcKeyFunction } from "../../utils/JcUtils";


export interface JcAppLocation<KeyT extends string> {
    readonly key: KeyT;
    readonly label: string;
    readonly onNavigate: () => void;
}

export const APP_LOC_KEY_FUNCTION: JcKeyFunction<JcAppLocation<string>> = location => location.key;
